import styled from "@emotion/styled";
import Header from "components/Header";
import { Outlet } from "react-router-dom";

export default function DefaultLayout() {
  return (
    <>
      <Header/>
      <Main><Outlet/></Main>
    </>
  );
}

const Main = styled("main")({
  paddingTop: "1rem"
});